import type { DataAssignment, DataIdentifier } from '@onefootprint/request-types/dashboard';

export const getDefaultValues = (dataAssignments: DataAssignment[]) => {
  if (!dataAssignments || dataAssignments.length === 0) {
    return [{ destination: '', source: '' }] as { destination: DataIdentifier | ''; source: string }[];
  }
  return dataAssignments.map(assignment => ({
    destination: assignment.destination.vault,
    source: assignment.source,
  }));
};
